@import ../../../styles/helpers

.videocallContainer
    position: absolute
    width: 100%
    height: 100%
    background-color: #000000c9
    z-index: 4
    display: flex
    justify-content: center
    align-items: center
    flex-direction: column
    border-radius: 20px
    border-top-right-radius: 0px
    padding: 50px
    gap: $external_margin

.videos
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    gap: $external_margin

.videoContainer
    width: 50%
    video
        width: 100%
    img
        width: 60%
        height: 60%
    .hide
        display: none

.actionBar
    display: flex
    gap: 20px
    button
        color: white